import ogPagesMixins from '@/mixins/ogPagesMixins'

export default {
  mixins: [ogPagesMixins],
  data() {
    return {
      products: [],
      productsCount: 0,
      page: this.$route.query?.page ? this.$route.query.page : 1,
    }
  },
  watch: {
    $route() {
      if (!this.$route.query?.page) {
        this.page = 1
        this.products = []
        this.$router.push({
          query: {},
        })
        this.fetchProducts()
      }
    },
  },

  methods: {
    paginateClick(page) {
      this.products = []
      if (page === 1) {
        this.$router.push({
          query: {},
        })
      } else {
        this.$router.push({
          query: {
            ...this.$route.query,
            page: this.page,
          },
        })
        this.fetchProducts()
      }
      this.$scrollTo('body')
    },

    updateProduct() {
      this.products = []
      this.fetchProducts()
    },

    loadMore() {
      this.page++
      this.$router.push({
        query: {
          ...this.$route.query,
          page: this.page,
        },
      })
      this.fetchProducts()
    },
  },
}
